"use client";

import LoadingIndicator from "@/components/dashboard/LoadingIndicator";

export default function Loading() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <LoadingIndicator />
    </div>
  );
}
